import { SkyscannerPmntdiscountpocsvcV1PaymentDiscount } from '@skyscanner-internal/pmnt-discount-poc-svc-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';

const PAYMENT_DISCOUNT_CLIENT_NAME = 'PAYMENT_DISCOUNT';

export const paymentDiscountRequest = grpcFetchClientWrapper(
  SkyscannerPmntdiscountpocsvcV1PaymentDiscount.PaymentDiscountService.GetPaymentDiscount,
  {
    clientName: PAYMENT_DISCOUNT_CLIENT_NAME,
    pathPrefix: '/g/pmnt-discount-poc-svc',
  },
);
